<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">客户公司</span>
            <el-input
              v-model="listQuery.customerCompanyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.businessNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务员</span>
             <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">工程师</span>
            <el-select :filterable="true" v-model="listQuery.engineerId" class="filter-item" placeholder="" remote clearable :size="t('table.btnSize')" @focus="handleEngineerFocus" @keyup.enter="handleFilter">
              <el-option
                v-for="item in engineerOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">订单编号</span>
            <el-input
              v-model="listQuery.orderNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">收款日期</span>
            <el-date-picker
              v-model="listQuery.receiveStartDate"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.receiveEndDate"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">业务时间</span>
            <el-date-picker
              v-model="listQuery.businessCreateStartDate"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.businessCreateEndDate"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @keyup.enter="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
          <div class="filter-box">
            <el-button
                v-waves
                class="filter-item "
                type="primary"
                :size="t('table.btnSize')"
                @click="handleFilter"
            >
                {{ t("table.search") }}
            </el-button>
            <el-button
                v-waves
                class="filter-item"
                :size="t('table.btnSize')"
                @click="handleReset"
            >
                {{ t("table.reset") }}
            </el-button>
            <el-button
                v-waves
                class="filter-item"
                :size="t('table.btnSize')"
                @click="isFilterCollapse = !isFilterCollapse"
            >
                {{ isFilterCollapse ? '展开' : '收起' }}
            </el-button>
            <span class="svg-icon cursor ml-10" @click="handleCommand('column')">
              <i class="icon-tubiao-28 iconfont"/>
            </span>
          </div>
      </div>
      <div class="split-table-layout">
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: `${topHeight}px` }"
        >
          <TableList
            :ref="el => { if (el) tableListRef[0] = el }"
            v-loading="listLoading"
            :dataList="list"
            :total="total"
            :columnAllData="columnAllData"
            :page="listQuery.page"
            :size="listQuery.size"
            :tableName="TableName"
            :permissionName="permissionName"
            @command-change="handleCommand"
            :can-change-column="false"
            :can-refresh="false"
            :canCommand="false"
            :megreColumn="['no', 'titleName', 'date']"
            :showSummary="true"
            :showIndex='true'
            :isShowPagination="false"
            :layoutHeight="true"
            :newHpx="newHpx"
            style="height:100% ;overflow:hidden;"
          >
            <template v-slot:operation-action="scope">
              <el-link
                v-permission="{ pkey: `${permissionName}_EDIT` }"
                href="javascript:void(0);"
                class="mr-10"
                type="primary"
                @click="handleCommand('edit', scope.row)"
              >
                {{ t("table.edit") }}
              </el-link>
              <el-link
                v-permission="{ pkey: `${permissionName}_DELETE` }"
                href="javascript:void(0);"
                type="danger"
                @click="handleCommand('delete', scope.row)"
              >
                {{ t("table.delete") }}
              </el-link>
            </template>
          </TableList>
          <el-pagination
            class="mt-20"
            v-show="total > 0"
            :total="total"
            v-model:currentPage="listQuery.page"
            :page-size="listQuery.size"
            :page-sizes="pageSizes"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next"
          />
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="pathApi"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById } from '@/apis/Dictionary'
import { getPageList } from '@/apis/Form'

import { PaymentAccountModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'
import { salesmanUser } from '@/apis/user'
import { defaultDate, pageVo, pageSizes, numberTimes, defaultDateTwoYears } from '@/utils/index'
import mixin from '@/mixins/index'
import { useTableSplitter } from '@/composables/useTableSplitter'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Materialclass',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_NOTICKETDETAIL,
      permissionName: permissionName.NOTICKETDETAIL,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,
      pathApi: 'materialClass',
      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        receiveStartDate: '',
        receiveEndDate: '',
        businessCreateStartDate: '',
        businessCreateEndDate: '',
        ...pageVo
      },
      dialogFormVisible: false,
      pageSizes,
      salesManOption: [],
      engineerOption: [],
      newHpx: 0,
      layouts: [
        { x: 0, y: 0, w: 12, h: 6, i: '0', maxW: 12, minW: 12, minH: 1 }
      ],

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        const { receiveStartDate, receiveEndDate, businessCreateStartDate, businessCreateEndDate } = dataMap.listQuery
        const tempsStart = receiveStartDate ? new Date(receiveStartDate).getTime() : 0
        const tempdEnd = receiveEndDate ? new Date(receiveEndDate).getTime() : 0
        const tempStartBusiness = businessCreateStartDate ? new Date(businessCreateStartDate).getTime() : 0
        const tempEndBusiness = businessCreateEndDate ? new Date(businessCreateEndDate).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        if (!tempStartBusiness) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempEndBusiness) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempStartBusiness > tempEndBusiness) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        getPageList('stat/no-invoicing', dataMap.listQuery).then((res: any) => {
          // dataMap.list = res.data?.flatMap((item: any) => {
          //   return item.businesses?.map((business: any) => {
          //     const obKeysArr = Object.keys(business)
          //     const tempObj = {} as any
          //     obKeysArr.forEach((jj: any) => {
          //       tempObj[`bussiness${jj.charAt(0).toUpperCase() + jj.slice(1)}`] = business[jj]
          //     })
          //     return {
          //       ...item,
          //       ...tempObj,
          //       id: item.id + business.id
          //     }
          //   }) || item
          // }) || []
          dataMap.list = res.data?.map((item: any) => {
            return {
              ...item,
              orderFeeTotal: dataMap.numberTimes(item.orderFee, item.amount, true),
              outCost: item.outCost - (item.outTaxFee ?? 0),
              partsCost: item.partsCost - (item.partsTaxFee ?? 0)
            }
          }) || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          receiveStartDate: defaultDate[0],
          receiveEndDate: defaultDate[1],
          businessCreateStartDate: defaultDateTwoYears[0],
          businessCreateEndDate: defaultDateTwoYears[1],
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getDetailById(dataMap.pathApi, row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey]
              })
            }
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById(dataMap.pathApi, row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadSalesMan() {
        salesmanUser().then((res: any) => {
          dataMap.salesManOption = res
        })
      },
      handleEngineerFocus() {
        getPageList('user/dropdown/engineers?all=true').then((res: any) => {
          dataMap.engineerOption = res || []
        })
      }
    })
    const { mixinData } = mixin(dataMap)
    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./statics/noTicketDetail',
      defaultRatio: 0,
      minTopHeight: 180,
      minBottomHeight: 0,
      splitterHeight: 0,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })

    onMounted(() => {
      mixinData.initHeight()
      dataMap.listQuery.receiveStartDate = defaultDate[0]
      dataMap.listQuery.receiveEndDate = defaultDate[1]
      dataMap.listQuery.businessCreateStartDate = defaultDateTwoYears[0]
      dataMap.listQuery.businessCreateEndDate = defaultDateTwoYears[1]
      dataMap.getList()
      dataMap.loadSalesMan()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), ...splitter, tableListRef }
  }
})
</script>
<style  lang="scss">

</style>
